import { Outlet, RouteObject } from "react-router-dom";
import RouteProtector from "./RouteProtector";
import { lazyWithReload } from "src/shared/services/lazyWithReload/lazyWithReload";

const NewCertificateApplicationForm = lazyWithReload(
  () =>
    import(
      "src/certificate/features/newCertificate/NewCertificateApplicationForm"
    ),
);
const CertificateAcknowledge = lazyWithReload(
  () => import("src/certificate/features/acknowledge/CertificateAcknowledge"),
);
const Form = lazyWithReload(() => import("src/certificate/features/form/form"));
const PastCertificateApplications = lazyWithReload(
  () =>
    import(
      "src/certificate/features/pastCertificateApplications/PastCertificateApplications"
    ),
);
const SubmitSuccess = lazyWithReload(
  () => import("src/certificate/features/submitSuccess/SubmitSuccess"),
);
const ActiveCertificateApplications = lazyWithReload(
  () =>
    import(
      "src/certificate/features/activeCertificateApplications/ActiveCertificateApplications"
    ),
);
const ManageCertificateApplication = lazyWithReload(
  () =>
    import(
      "src/certificate/features/manageCertificates/ManageCertificateApplication"
    ),
);
export const certificatePaths: RouteObject = {
  path: "/certificate",
  element: <Outlet />,
  children: [
    {
      path: "newCertificateApplicationForm",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser", "isBusiness"]}>
          <NewCertificateApplicationForm />
        </RouteProtector>
      ),
    },
    {
      path: "form",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser", "isBusiness"]}>
          <Form />
        </RouteProtector>
      ),
    },
    {
      path: "acknowledge",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser", "isBusiness"]}>
          <CertificateAcknowledge />
        </RouteProtector>
      ),
    },
    {
      path: "activeCertificateApplications",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser", "isBusiness"]}>
          <ActiveCertificateApplications />
        </RouteProtector>
      ),
    },
    {
      path: "pastCertificateApplications",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser", "isBusiness"]}>
          <PastCertificateApplications />
        </RouteProtector>
      ),
    },
    {
      path: "submitSuccess",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser", "isBusiness"]}>
          <SubmitSuccess />
        </RouteProtector>
      ),
    },
    {
      path: "manageCertificateApplication",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser", "isBusiness"]}>
          <ManageCertificateApplication />
        </RouteProtector>
      ),
    },
  ],
};
